import { createLocaleMessages } from "./createLocaleMessages";

export const FR_TRANSLATIONS = createLocaleMessages({
  common: {
    appName: "Screen0",
    loading: "Chargement…",
    loadingSettings: "Chargement des réglages",
    loadingInsight: "Chargement de l'insight…",
    close: "Fermer",
    cancel: "Annuler",
    save: "Enregistrer",
    delete: "Supprimer",
    done: "Terminé",
    send: "Envoyer",
    add: "Ajouter",
    create: "Créer",
    edit: "Modifier",
    available: "Disponible",
    unavailable: "Indisponible",
    checking: "vérification",
    somethingWentWrong: "Une erreur s'est produite",
    today: "Aujourd'hui",
    thisWeek: "Cette semaine",
    thisMonth: "Ce mois",
    backToToday: "Retour à Aujourd'hui",
    openSettings: "Ouvrir les réglages",
    primaryNavLabel: "Principal",
    noUsage: "Aucune utilisation",
    emDash: "—",
    thinking: "Réflexion...",
    opening: "Ouverture…",
    ok: "OK",
    dismiss: "Ignorer",
    unknown: "Inconnu",
  },
  navigation: {
    today: "Aujourd'hui",
    habits: "Habitudes",
    insight: "Insight",
    rules: "Règles",
    settings: "Réglages",
    premiumLocked: "Premium",
  },
  today: {
    titleToday: "Aujourd'hui",
    titleThisWeek: "Cette semaine",
    titleThisMonth: "Ce mois",
    periodDay: "Jour",
    periodWeek: "Semaine",
    periodMonth: "Mois",
    periodLabel: "Période",
    viewApps: "Apps",
    viewCategories: "Catégories",
    metricScreenTime: "Temps d'écran",
    metricScreenTimeAndroid: "Temps d'utilisation",
    metricActivations: "Activations",
    viewToggleAria: "Vue : {view}. Appuyez pour changer.",
    metricToggleAria: "Métrique : {metric}. Appuyez pour changer.",
    periodToggleAria: "Période : {period}. Appuyez pour changer.",
    prevNavAria: "{period} précédent",
    nextNavAria: "{period} suivant",
    navDay: "jour",
    navWeek: "semaine",
    navMonth: "mois",
    noSnapshotDayTitle: "Aucun instantané pour ce jour",
    noSnapshotWeekTitle: "Aucun instantané pour cette semaine",
    noSnapshotMonthTitle: "Aucun instantané pour ce mois",
    noSnapshotDayBody:
      "Aucun instantané n'a été enregistré pour ce jour. Essayez une autre date ou revenez à aujourd'hui.",
    noSnapshotWeekBody:
      "Cette semaine n'a pas encore assez d'instantanés enregistrés. Essayez une semaine antérieure ou revenez après d'autres captures quotidiennes.",
    noSnapshotMonthBody:
      "Ce mois n'a pas encore assez d'instantanés enregistrés. Essayez un mois antérieur ou revenez après d'autres captures quotidiennes.",
    preInstallDayTitle: "Aucune donnée pour ce jour",
    preInstallDayBody:
      "Les données d'utilisation ne sont disponibles qu'à partir de la première installation de Screen0 sur cet appareil. Les dates antérieures ne sont pas disponibles.",
    preInstallWeekTitle: "Aucune donnée pour cette semaine",
    preInstallWeekBody:
      "Cette semaine entière est antérieure à l'installation de Screen0 sur cet appareil, donc aucune donnée d'utilisation n'est disponible.",
    preInstallMonthTitle: "Aucune donnée pour ce mois",
    preInstallMonthBody:
      "Ce mois entier est antérieur à l'installation de Screen0 sur cet appareil, donc aucune donnée d'utilisation n'est disponible.",
    noUsageRecorded: "Aucune utilisation enregistrée",
    permissionNeededTitle: "Autorisation requise pour le rapport du jour",
    permissionNeededBody:
      "Screen0 fonctionne sans compte, mais iOS exige l'autorisation Temps d'écran avant d'afficher l'utilisation des apps.",
    permissionDeniedHint:
      "Ouvrez Réglages et appuyez sur Demander l'accès Temps d'écran, puis approuvez la boîte de dialogue Apple « Utilisation des apps et des sites web » pour débloquer le rapport du jour.",
    reasonIosDataExportRequires264:
      "Apple n'autorise la lecture des données Temps d'écran qu'à partir d'iOS 26.4. Mettez iOS à jour pour voir l'utilisation ici.",
    reasonDataExportUnavailable:
      "Apple n'autorise actuellement l'export des données Temps d'écran que sur les appareils de l'UE, donc aucune utilisation ne peut être lue sur cet appareil.",
    reasonExtensionSnapshotMissing:
      "L'extension de rapport a démarré, mais l'instantané du groupe d'apps n'était pas lisible lors de cette exécution.",
    reasonReportViewNotMounted:
      "Screen0 n'a pas pu monter l'hôte natif du rapport Activité de l'appareil.",
    reasonDefaultNoData:
      "Utilisez votre téléphone quelques minutes, puis revenez à Aujourd'hui ou rouvrez Screen0. iOS peut aussi ne renvoyer aucune donnée en début de journée.",
    permissionNeededBodyAndroidRestricted:
      "Android a bloqué cette autorisation car Screen0 a été installé hors d'une boutique d'applications. Touchez d'abord « Ouvrir les infos de l'app Screen0 » ci-dessous, ouvrez le menu ⋮ en haut à droite et choisissez « Autoriser les paramètres restreints » (confirmez avec votre code PIN). Revenez ensuite et activez l'accès aux données d'utilisation.",
    openAppInfo: "Ouvrir les infos de l'app Screen0",
    reasonDefaultNoDataAndroid:
      "L'accès aux données d'utilisation est actif. Utilisez l'appareil quelques minutes, puis revenez à Aujourd'hui ou rouvrez Screen0 — Android peut mettre un moment à renvoyer les premières données.",
    collectingUsageTitle: "Lecture des données d'utilisation…",
    collectingUsageBody:
      "L'accès aux données d'utilisation est actif. Screen0 lit l'utilisation d'aujourd'hui — cela ne prend qu'un instant.",
    collectingUsageBodyAndroid:
      "L'accès aux données d'utilisation est actif. Screen0 lit l'utilisation d'aujourd'hui depuis Android — juste après l'autorisation, cela peut prendre quelques secondes.",
    reasonUsageEventsUnavailableAndroid:
      "L'accès aux données d'utilisation semble actif, mais Android ne partage pas encore de données avec Screen0. Ouvrez les Réglages, désactivez puis réactivez l'accès pour Screen0, puis rouvrez l'app. Pour les installations hors boutique, choisissez d'abord « Autoriser les paramètres restreints » depuis Infos de l'app (menu ⋮).",
    reasonAppsNotVisibleAndroid:
      "Android a enregistré de l'utilisation, mais Screen0 n'a pas pu identifier les apps. Mettez à jour ou réinstallez Screen0, puis réessayez.",
    weeklyActivationsNotTracked: "Les activations hebdomadaires ne sont pas encore suivies",
    monthlyActivationsNotTracked: "Les activations mensuelles ne sont pas encore suivies",
    activationsNotTracked: "Activations pas encore suivies",
    topApps: "Apps principales",
    allApps: "Toutes les apps",
    topCategories: "Catégories principales",
    allCategories: "Toutes les catégories",
    topActivations: "Activations principales",
    allActivations: "Toutes les activations",
    topCategoryActivations: "Activations par catégorie principales",
    allCategoryActivations: "Toutes les activations par catégorie",
    viewAllAppsAria: "Voir toutes les apps",
    viewAllCategoriesAria: "Voir toutes les catégories",
    viewAllActivationsAria: "Voir toutes les activations",
    viewAllCategoryActivationsAria: "Voir toutes les activations par catégorie",
    dayShape: "Forme du jour",
    weekShape: "Forme de la semaine",
    monthShape: "Forme du mois",
    dailyAverage: "Moy./j",
    dailyAverageOn: "activée",
    dailyAverageOff: "désactivée",
    dailyAverageToggleAria: "Moyenne quotidienne {state}. Appuyez pour basculer.",
  },
  habits: {
    title: "Habitudes",
    timeframe: "12 derniers mois",
    reorder: "Réorganiser les apps",
    doneReordering: "Réorganisation terminée",
    openFilter: "Ouvrir le filtre habitudes",
    metricToggleAria: "Métrique : {metric}. Appuyez pour changer.",
    emptyTitle: "Aucune donnée d'utilisation des apps",
    emptyBody:
      "Autorisez l'accès Temps d'écran depuis Aujourd'hui pour suivre vos habitudes.",
    emptyBodyAndroid:
      "Autorisez l'accès aux données d'utilisation depuis Aujourd'hui pour suivre vos habitudes.",
    filterView: "Vue",
    filterTrackApps: "Suivre les apps",
    filterTrackCategories: "Suivre les catégories",
    filterCategories: "Catégories",
    filterShowingAll: "Tout afficher. Sélectionnez pour ne suivre que certains éléments.",
    filterTrackingSelected: "Suivi de {count} sélectionnés.",
    filterSearchPlaceholder: "Rechercher les apps que vous avez utilisées",
    filterSearchAria: "Rechercher des apps",
    closeFilter: "Fermer le filtre",
    previousMonth: "Mois précédent",
    nextMonth: "Mois suivant",
    filterOtherSection: "Bucket Autre",
    includeOther: "Inclure Autre",
    includeOtherAria: "Inclure le bucket Autre dans les habitudes",
    includeOtherInfoAria: "Qu'est-ce que le bucket Autre ?",
    otherInfoTitle: "Qu'est-ce qu'Autre ?",
    otherInfoBody:
      "Autre correspond au temps d'écran qu'iOS n'a pas pu attribuer à une app précise. Il provient souvent d'apps désinstallées, d'utilisation système ou de petits écarts entre votre temps d'écran total et la somme des apps individuelles.",
    otherInfoBodyAndroid:
      "Autre correspond au temps d'utilisation qu'Android n'a pas pu attribuer à une app précise. Il provient souvent d'apps désinstallées, d'utilisation système ou de petits écarts entre votre total et la somme des apps individuelles.",
  },
  insight: {
    title: "Insight",
    timeframe: "{days} derniers jours",
    compulsivity: "Compulsivité",
    doomScrollRisk: "Doom-scroll",
    aboutMetricAria: "À propos de {metric}",
    compulsivityBody1:
      "À quelle fréquence vous rouvrez les mêmes apps par rapport à tout le reste sur votre téléphone. Des scores élevés signifient généralement des déverrouillages fréquents et des visites répétées, pas seulement de longues sessions.",
    compulsivityBody2:
      "Screen0 combine la fréquence d'ouverture d'une app, le temps total qu'elle occupe et le nombre de jours où elle apparaît dans vos instantanés récents.",
    compulsivityBody3:
      "Ce sont des estimations proxy des 14 derniers jours — des tendances utiles, pas une mesure clinique.",
    doomBody1:
      "Apps dont l'utilisation tend à se répéter et à se concentrer sur quelques heures de la journée — le type de schéma qui peut dériver vers un défilement automatique, à tout moment.",
    doomBody2:
      "Screen0 pondère le temps qu'occupe une app, sa régularité d'apparition et la concentration de cette utilisation au fil de la journée dans vos instantanés récents.",
    doomBody3:
      "Les scores sont des estimations proxy des 14 derniers jours et reflètent des habitudes, pas des intentions.",
    activateSmartBlockAria: "Activer Smart Block pour {appName}",
    reactivateSmartBlockAria: "Réactiver Smart Block pour {appName}",
    activeSmartBlocksTitle: "Smart Blocks actifs",
    activeSmartBlocksAria: "Règles Smart Block actives sur cet appareil",
    goToActiveSmartBlockRuleAria: "Aller à la règle pour {appName}",
    activateSmartBlockTitle: "Activer ce Smart Block ?",
    reactivateSmartBlockTitle: "Réactiver ce Smart Block ?",
    activateConfirmBody:
      "Crée une règle active qui suspend {appName} chaque jour, {window}.",
    reactivateConfirmBody:
      "Réactive votre règle existante pour {appName} chaque jour, {window}.",
    activate: "Activer",
    reactivate: "Réactiver",
    notFoundTitle: "Insight introuvable",
    notFoundBody: "Cet insight a peut-être été supprimé ou n'a pas encore été généré.",
    statusPermissionNeededBodyAndroid:
      "Autorisez l'accès aux données d'utilisation depuis Aujourd'hui avant qu'Insight puisse évaluer les habitudes d'apps récentes.",
    openExclude: "Gérer les apps exclues d'Insight",
    excludeSheetTitle: "Exclure d'Insight",
    closeExclude: "Fermer les exclusions",
    excludeSectionLabel: "Apps exclues",
    excludeHelperAllIncluded:
      "Toutes les apps sont incluses dans les scores Insight. Cochez les apps à exclure de la compulsivité, du doom-scroll et des suggestions Smart Block.",
    excludeHelperCount: "{count} apps exclues des scores Insight.",
    excludeSearchPlaceholder: "Rechercher des apps que vous avez utilisées",
    excludeSearchAria: "Rechercher des apps",
    excludeSearchResults: "Résultats de recherche",
    excludeSearching: "Recherche…",
    excludeNoMatchingApps: "Aucune app correspondante",
    excludeNoApps: "Aucune app dans cette période pour l'instant",
    excludeIncludeAll: "Tout inclure",
    smartBlockPrePickerTitle: "Choisir des apps dans Temps d'écran",
    smartBlockPrePickerReactivateTitle: "Resélectionner des apps dans Temps d'écran",
    smartBlockPrePickerBody:
      "L'écran suivant est le sélecteur d'apps d'Apple. Choisissez {appName} pour que Screen0 puisse la bloquer pendant cette fenêtre Smart Block.",
    smartBlockPrePickerReactivateBody:
      "L'écran suivant est le sélecteur d'apps d'Apple. Choisissez à nouveau {appName} pour que Screen0 applique ce Smart Block.",
    smartBlockPrePickerNext: "Suivant",
    smartBlockPickerTitle: "Choisir {appName}",
    smartBlockPickerHeader: "Choisir {appName}",
    smartBlockPickerFooter:
      "Sélectionnez l'app suggérée par votre Smart Block. Screen0 ne peut pas vérifier votre choix — choisissez avec soin.",
    smartBlockHonorTitle: "Avez-vous choisi {appName} ?",
    smartBlockHonorBody:
      "Sur l'écran précédent, vous deviez sélectionner l'app visée par ce Smart Block.",
    smartBlockHonorYes: "Oui, continuer",
    smartBlockHonorNo: "Non",
    smartBlockDeclinedTitle: "Le Smart Block nécessite {appName}",
    smartBlockDeclinedBody:
      "Ce Smart Block ne peut pas être créé sans choisir {appName} dans le sélecteur d'Apple.",
    smartBlockRetryPicker: "Réessayer",
    smartBlockNonConformingTitle: "La sélection ne correspond pas au Smart Block",
    smartBlockNonConformingBody:
      "Vous avez sélectionné {appCount} apps, {categoryCount} catégories et {siteCount} sites web. La règle peut quand même être créée, mais ne sera pas étiquetée Smart Block.",
    smartBlockNonConformingContinue: "Créer une règle manuelle",
  },
  rules: {
    title: "Règles",
    reorder: "Réorganiser",
    doneReordering: "Réorganisation terminée",
    dismiss: "Ignorer",
    activeRulesTitle: "Règles planifiées",
    activeRulesLoading: "Chargement…",
    activeRulesEnforcing: "{count} appliquées maintenant",
    activeRulesEmptySchedule: "Planifier une suspension",
    noActiveRulesTitle: "Aucune règle planifiée",
    noActiveRulesBody:
      "Choisissez quoi bloquer, quand et quels jours — votre première règle prend environ une minute.",
    newRule: "Nouvelle règle",
    targetsTitle: "Objectifs",
    targetsSaved: "{count} enregistrés",
    targetsEmptySubtitle: "Groupes de blocage réutilisables pour apps et sites",
    noTargetsTitle: "Aucun objectif",
    noTargetsBody:
      "Créez un groupe nommé d'apps, de sites ou de catégories — puis réutilisez-le dans les règles et sessions rapides.",
    newTarget: "Nouvel objectif",
    addSectionAria: "Ajouter {title}",
    deleteRuleAria: "Supprimer la règle",
    deleteTargetAria: "Supprimer la cible",
    deleteRuleConfirmAria: "Supprimer cette règle ?",
    deleteTargetConfirmAria: "Supprimer cette cible ?",
    deleteRuleConfirm: "Supprimer cette règle ?",
    deleteTargetConfirm: "Supprimer cette cible ?",
    deleteRuleCoveredConfirm:
      "Supprimer cette règle ? Les mêmes apps et sites restent bloqués par une autre règle active.",
    deleteTargetCoveredConfirm:
      "Supprimer cette cible ? Les mêmes apps et sites restent bloqués par une autre règle active.",
    deleteRuleCoveredConfirmAria: "Supprimer cette règle tout en maintenant le blocage ?",
    deleteTargetCoveredConfirmAria: "Supprimer cette cible tout en maintenant le blocage ?",
    editRuleAria: "Modifier {name}",
    editTargetAria: "Modifier {targetName}",
    enableRuleAria: "Activer la règle",
    disableRuleAria: "Désactiver la règle",
    noTargets: "Aucun objectif",
    ruleUpdated: "Règle mise à jour.",
    ruleCreated: "Règle créée.",
    ruleSaveFailed: "Impossible d'enregistrer la règle. Réessayez.",
    targetCreated: "Objectif créé.",
    targetUpdated: "Objectif mis à jour.",
    targetSaveFailed: "Impossible d'enregistrer l'objectif. Réessayez.",
    ruleDeleted: "Règle supprimée.",
    targetDeleted:
      "Cible supprimée. Les règles n'utilisant que cette cible ont été supprimées.",
    editRule: "Modifier la règle",
    newRuleEditor: "Nouvelle règle",
    saveRule: "Enregistrer la règle",
    createRule: "Créer la règle",
    editTarget: "Modifier l'objectif",
    newTargetEditor: "Nouvel objectif",
    saveTarget: "Enregistrer l'objectif",
    createTarget: "Créer l'objectif",
    targetsSection: "Objectifs",
    targetsLimitHint: "Jusqu'à {max} par règle",
    targetsLimitReached: "Vous pouvez sélectionner jusqu'à {max} objectifs par règle. Désélectionnez-en un pour en ajouter un autre.",
    targetsRequired: "Sélectionnez au moins un objectif pour enregistrer cette règle.",
    targetEditorFromRule: "Ajouter un objectif pour cette règle",
    targetEditorFromQuickStart: "Ajouter un objectif pour le démarrage rapide",
    backToRule: "Retour à la règle",
    backToQuickStart: "Retour au démarrage rapide",
    websiteCategoriesLink: "Parcourir les catégories de sites",
    websiteCategoriesHint: "Bloquez des groupes entiers comme Réseaux sociaux ou Actualités — sans saisir de domaines.",
    createTargetCta: "Créer votre premier objectif",
    createTargetHint: "Nommez un groupe d'apps ou de sites, puis choisissez-le dans les règles.",
    daysSection: "Jours",
    timeWindowSection: "Plage horaire",
    startLabel: "Début",
    endLabel: "Fin",
    endsLabel: "Se termine",
    durationMode: "Durée",
    endTimeMode: "Heure de fin",
    blockDurationAria: "Durée du blocage en minutes",
    targetNamePlaceholder: "ex. Réseaux sociaux, Distractions travail",
    chooseAppsSites: "Choisir les apps et sites à bloquer",
    websitePlaceholder: "exemple.com",
    websiteAria: "Domaine du site web",
    tapToChangeBlocked: "Appuyez pour modifier ce qui est bloqué",
    chosenOnDevice: "Choisi sur cet iPhone",
    changeBlockedAppsAria: "Modifier les apps bloquées",
    viewFullBlockedListAria: "Voir la liste complète des éléments bloqués",
    view: "Voir",
    smartBlockBadge: "Smart Block",
    smartBlockRuleWindowTitle: "Modifier l'horaire du Smart Block",
    smartBlockRuleWindowBody:
      "Vous pouvez uniquement modifier quand ce Smart Block est actif. Les apps, les jours et les autres réglages restent verrouillés.",
    smartBlockRuleWindowAria: "Modifier la plage horaire du Smart Block",
    smartBlockMinDurationError: "Les Smart Blocks doivent durer au moins 1 heure.",
    smartBlockEndBeforeStartError: "L'heure de fin doit être après l'heure de début.",
    smartBlockRuleNotEditable: "Vous ne pouvez pas modifier une règle Smart Block.",
    smartBlockTargetNotEditable: "Les objectifs Smart Block ne peuvent pas être modifiés.",
    smartBlockRuleNotEditableAria: "Règle Smart Block non modifiable",
    smartBlockTargetNotEditableAria: "Objectif Smart Block non modifiable",
    enforcementBannerTitle: "En application maintenant",
    enforcementBannerEndsIn: "Se termine dans {time}",
    enforcementBannerMore: "+{count} de plus",
    enforcementBreakBannerTitle: "Pause en cours",
    enforcementBreakBannerEndsIn: "Se termine dans {time}",
    quickStart: {
      fabLabel: "Démarrer",
      fabAria: "Démarrer une session de blocage rapide",
      drawerTitle: "Démarrage rapide",
      durationLabel: "Durée",
      durationAria: "Durée de la session rapide en minutes",
      recentTab: "Récentes",
      savedTab: "Enregistrées",
      savePrompt: "Nommez cette session",
      savePromptTitle: "Enregistrer en favoris",
      savePromptHint: "Appuyez sur l'étoile d'une session récente pour la réutiliser en un tap.",
      saveNamePlaceholder: "ex. Heure focus",
      noRecents: "Aucune session récente",
      noSaved: "Aucune session enregistrée",
      createTarget: "Nouvel objectif",
      changeIcon: "Changer l'icône",
      sessionActive: "Blocage actif",
      saveStarAria: "Enregistrer la session",
      savedStarAria: "Session enregistrée",
      defaultSessionName: "Session",
      startButton: "Démarrer la session",
      noValidTargets: "Ces objectifs ont été supprimés. Sélectionnez au moins un objectif.",
    },
    swipeUnlock: {
      trackLabel: "Glissez pour arrêter le blocage",
      trackAria: "Faites glisser pour arrêter tous les blocages",
      overlayTitle: "Maintenez pour déverrouiller",
      overlayBody: "Cela arrête immédiatement toutes les règles et sessions actives. Maintenez pour confirmer que vous voulez vraiment déverrouiller.",
      holdAria: "Maintenez pour confirmer",
      holdHint: "Continuez à maintenir…",
      takeBreak: "Faire une pause de {minutes} minutes",
    },
    forcedSuspend: {
      badge: "En pause",
      subtitle: "Appuyez sur power pour reprendre le blocage.",
      autoResume: "Reprend {time}.",
      resumeRuleAria: "Reprendre le blocage pour cette règle",
    },
    vpnInstallPrompt: {
      title: "Installez le filtre de sites",
      body: "Une règle bloque des sites en ce moment. Installez le profil VPN sur l'appareil pour qu'ils restent bloqués dans Safari.",
      bodyAndroid:
        "Une règle bloque des sites en ce moment. Installez le profil VPN sur l'appareil pour qu'ils restent bloqués dans Chrome et les autres navigateurs.",
      install: "INSTALLER LE PROFIL",
      installing: "INSTALLATION…",
      notNow: "PAS MAINTENANT",
      dismissAria: "Fermer l'invite du filtre de sites",
    },
    vpnWebTargetGate: {
      title: "Filtre de sites requis",
      body:
        "Le blocage de sites nécessite le profil filtre sur l'appareil. Les objectifs apps seuls fonctionnent sans — installez le profil pour ajouter des domaines ou catégories.",
      banner:
        "Installez le filtre de sites sur l'appareil pour ajouter des domaines ou catégories ici.",
      install: "INSTALLER LE PROFIL",
      installing: "INSTALLATION…",
      continueAppsOnly: "Apps seulement",
      dismissAria: "Fermer l'exigence du filtre de sites",
      saveBlocked: "Installez le filtre de sites pour enregistrer de nouveaux domaines ou catégories.",
    },
  },
  chat: {
    title: "Demander à Screen0",
    engineIosLocal: "IA locale sur iOS",
    engineAndroidLocal: "IA locale sur Android",
    engineCloud: "IA cloud",
    closeChatAria: "Fermer le chat",
    suggestionWhatChanged: "Qu'est-ce qui a changé aujourd'hui ?",
    suggestionWhichApp: "Quelle app m'a attiré ?",
    suggestionTonight: "Que tester ce soir ?",
    placeholder: "Posez une question sur votre utilisation",
    sendAria: "Envoyer",
    unableToAnswer: "Impossible de répondre pour le moment.",
    localAiUnavailableSuffix:
      "L'IA locale est indisponible pour le moment. Le chat cloud n'est pas utilisé automatiquement sur cet appareil.",
  },
  insightChat: {
    fabAria: "Demander des infos sur votre utilisation du téléphone",
    title: "Chat d'utilisation",
    privacyBadge: "100 % sur l'appareil",
    engineIosLocal: "IA locale sur iOS",
    engineAndroidLocal: "IA locale sur Android",
    greeting:
      "Que souhaitez-vous savoir sur votre utilisation du téléphone ? Je peux expliquer les tendances de votre fenêtre Insight récente.",
    suggestionTotalUsage: "Combien ai-je utilisé mon téléphone ?",
    suggestionTopApp: "Quelle app j'utilise le plus ?",
    suggestionBusiestDays: "Quels jours j'utilise le plus mon téléphone ?",
    suggestionBusiestBands: "Quelles plages horaires sont les plus chargées ?",
    suggestionTopAppWhy: "Pourquoi j'utilise autant {appName} ?",
    suggestionTopAppWhyGeneric: "Pourquoi j'utilise autant mon app la plus utilisée ?",
    suggestionComparePeriods: "Comparer cette période à la précédente",
    placeholder: "Posez une question sur vos habitudes",
    sendAria: "Envoyer le message",
    closeAria: "Fermer le chat d'utilisation",
    unableToAnswer: "Impossible de répondre pour le moment.",
    contextLoading: "Préparation du contexte d'utilisation…",
    contextError: "Impossible de charger le contexte d'utilisation. Réessayez ou fermez et rouvrez le chat.",
    contextEmpty: "Pas encore assez de données d'utilisation récentes pour le chat.",
    retryContext: "Réessayer",
  },
  settings: {
    title: "Réglages",
    controlsEyebrow: "Contrôles",
    screenTimeSection: "Temps d'écran",
    screenTimeSectionAndroid: "Accès aux données d'utilisation",
    permissionLabel: "Autorisation",
    requestingAccess: "Demande d'accès en cours",
    requestScreenTimeAccess: "Demander l'accès Temps d'écran",
    legalSection: "Mentions légales",
    privacyPolicyRow: "Politique de confidentialité",
    termsRow: "Conditions",
    resetSection: "Réinitialiser",
    deletingSavedData: "Suppression des données enregistrées",
    deleteSavedData: "Supprimer les données enregistrées et réinitialiser l'ID appareil",
    resetSuccess:
      "{count} enregistrements supprimés. Un nouvel identifiant d'appareil anonyme a été créé.",
    resetFailed: "Échec de la réinitialisation.",
    footerNoAccount: "Aucun compte requis.",
    languageRow: "Langue",
    purchasesSection: "Achats",
  },
  language: {
    eyebrow: "Langue de l'app",
    title: "Langues",
    subtitle:
      "Screen0 suit la langue préférée de l'app configurée dans le système. Changez-la depuis Réglages iPhone quand vous voulez.",
    subtitleAndroid:
      "Screen0 suit la langue préférée de l'app configurée dans le système. Changez-la depuis les réglages Android quand vous voulez.",
    subtitleAndroidLegacy:
      "Sur cette version d'Android, Screen0 suit la langue de l'appareil. Changez-la dans Réglages → Langues et saisie.",
    activeLanguageLabel: "Langue active",
    systemLanguageLabel: "Préférence système",
    fallbackNote:
      "La langue système sélectionnée n'est pas encore prise en charge par Screen0, l'app utilise donc l'anglais par défaut.",
    unavailableSystemValue: "Non disponible",
    openSettingsTitle: "Ouvrir Réglages iPhone",
    openSettingsTitleAndroid: "Ouvrir les réglages de langue de l'app",
    openSettingsTitleAndroidLegacy: "Ouvrir les réglages Android",
    openSettingsSubtitle:
      "Accédez à la page système de Screen0 pour changer la langue de l'app.",
    openSettingsSubtitleAndroid:
      "Accédez à la page de langue de Screen0 pour changer la langue de l'app.",
    openSettingsSubtitleAndroidLegacy:
      "La fiche de l'app s'ouvre ici. Changez la langue de l'appareil dans Langues — la langue par app nécessite Android 13 ou plus.",
    openingSettingsLabel: "Ouverture des Réglages",
    closeLabel: "Fermer",
    footerReady:
      "Quand vous revenez dans l'app, Screen0 synchronise automatiquement la langue mise à jour.",
    footerReadyAndroid:
      "Quand vous revenez dans l'app, Screen0 synchronise automatiquement la langue mise à jour.",
    footerReadyAndroidLegacy:
      "Quand vous revenez dans l'app, Screen0 se synchronise avec la langue de l'appareil.",
    footerOpening: "Ouverture de la page système...",
    openSettingsUnavailableTitle: "Réglages indisponibles",
    openSettingsUnavailableDescription:
      "Impossible d'ouvrir les Réglages de l'app depuis cet environnement.",
  },
  permission: {
    gateTitle: "Autorisation requise pour le rapport du jour",
    gateBody:
      "Screen0 fonctionne sans compte, mais iOS exige l'autorisation Temps d'écran avant d'afficher l'utilisation des apps.",
    requestingAccess: "Demande d'accès en cours",
    requestScreenTimeAccess: "Demander l'accès Temps d'écran",
    entitlementMissing:
      "Cette build n'inclut pas l'entitlement Family Controls ou le profil d'approvisionnement correspondant. Les données Temps d'écran ne peuvent pas être collectées tant que la signature n'est pas corrigée.",
  },
  calendar: {
    chooseDate: "Choisir une date",
    previousMonth: "Mois précédent",
    nextMonth: "Mois suivant",
  },
  query: {
    loadingDefault: "Chargement…",
    errorTitle: "Une erreur s'est produite",
  },
  app: {
    syncError:
      "Impossible d'enregistrer l'utilisation du jour. Screen0 réessaiera lorsque vous rouvrirez l'app.",
    reinstallRulesPurged:
      "Vos règles de blocage ont été réinitialisées : les sélections d'apps ne survivent pas à une réinstallation. Reconfigurez-les dans Règles.",
  },
  format: {
    activationSingular: "Activation",
    activationPlural: "Activations",
    durationMinutes: "{minutes} min",
    durationHoursOnly: "{hours} h",
    durationOneHour: "1 h",
    durationHoursMinutes: "{hours} h {minutes} min",
    allDay: "Toute la journée",
    timeBandMorning: "matin",
    timeBandAfternoon: "après-midi",
    timeBandEvening: "soir",
    timeBandNight: "nuit",
  },
  appDetail: {
    dailyAverage: "Moyenne quotidienne",
    dailyAverageInfoAria: "À propos de la moyenne quotidienne ({metric})",
    dailyAverageInfoBodyTime1:
      "Temps d'écran horaire moyen de cette app sur les ~12 derniers mois.",
    dailyAverageInfoBodyTime2:
      "Chaque heure est la moyenne sur tous les jours avec des données appareil sur cette période. Les jours sans utilisation de cette app comptent comme zéro. Les jours avant le début de la collecte sont exclus.",
    dailyAverageInfoBodyOpens1:
      "Activations horaires moyennes de cette app sur les ~12 derniers mois.",
    dailyAverageInfoBodyOpens2:
      "Chaque heure est la moyenne sur tous les jours avec des données appareil sur cette période. Les jours sans utilisation de cette app comptent comme zéro. Les jours avant le début de la collecte sont exclus.",
    panelCalendar: "Calendrier",
    panelChart: "Graphique",
    noUsage: "Aucune utilisation",
  },
  ring: {
    screenTime: "Temps d'écran",
    activations: "Activations",
    percentOfTotal: "{percent} % du total",
    notTracked: "Non suivi",
    screenActivationsByApp: "Activations d'écran par app",
    screenTimeByApp: "Temps d'écran par app",
    showScreenTime: "Afficher le temps d'écran",
    showScreenActivations: "Afficher les activations d'écran",
    chartDescriptionDay:
      "Temps d'écran et activations horaires pour le jour sélectionné",
    chartDescriptionWeek:
      "Temps d'écran et activations quotidiennes pour la semaine sélectionnée",
    chartDescriptionMonth:
      "Temps d'écran et activations quotidiennes pour le mois sélectionné",
  },
  smartBlock: {
    goalDoom: "Réduire le doom-scroll",
    goalCompulsivity: "Réduire la compulsivité",
    actionLabel: "Bloquer entièrement {range}",
    reasonDoomShare:
      "{sharePct} % de votre utilisation de {name} a lieu entre {range}. Bloquer cette plage cible la période à plus haut risque.",
    reasonDoomCluster:
      "L'utilisation de {name} tend à se concentrer à ce moment de la journée. Bloquer {range} cible la période à plus haut risque.",
    reasonCompulsivityOpens: "Vous ouvrez {name} le plus souvent entre {range}.",
    reasonCompulsivityTime: "La majeure partie de votre temps sur {name} se situe entre {range}.",
    reasonCompulsivityShareSuffix:
      "Un blocage complet sur cette plage interrompt la boucle de l'habitude.",
    reasonCompulsivityRepeat:
      "{name} reçoit des déverrouillages répétés à ce moment de la journée. Un blocage complet entre {range} interrompt la boucle de l'habitude.",
    reactivateHint: "La règle existe mais est désactivée — appuyez pour la réactiver",
  },
  permissionStatus: {
    granted: "Accordée",
    denied: "Refusée",
    unavailable: "Indisponible",
    notDetermined: "Non déterminée",
  },
  onboarding: {
    progressLabel: "Progression de l'onboarding",
    continue: "Continuer",
    working: "Traitement…",
    goToToday: "Aller à Aujourd'hui",
    narrative4Cta: "Pour quoi voulez-vous ce temps ?",
    narrative1ImageAlt: "Zero avec un écran en main sans s'en rendre compte",
    narrative2ImageAlt: "Zero tiré par des fils vers un écran lumineux",
    narrative3ImageAlt: "Zero à table sans téléphone",
    narrative4ImageAlt: "Zero faisant le premier pas sur un chemin sans téléphone",
    narrative1: [
      "Avez-vous déjà remarqué comment vous vous retrouvez avec un écran en main sans même vous en rendre compte ? Il suffit de **15 secondes** d'attente et vous cherchez déjà l'écran.",
      "Nous avons appris à **ne laisser vide** et à ne pas contempler ne serait-ce qu'un instant.",
      "Ping, scroll, onglet : il est facile de se sentir confus et **divisé**.",
    ],
    narrative2: [
      "Ce n'est pas un manque de **force et de volonté**. Les apps sont conçues et ingéniées pour **vous garder là** : chaque scroll rend plus difficile de **vous détacher**.",
      "Screen0 vous aide à **créer de la distance**, pas à essayer d'être **parfait**.",
    ],
    narrative3: [
      "Moins d'écran ne signifie pas moins de vie, cela veut dire plus d'**espace** pour le travail, les gens, le sommeil.",
      "Revivez un repas sans téléphone, une soirée sans scroll : les limites semblent petites, mais elles font une **grande différence**.",
    ],
    narrative4: [
      "**Vous avez déjà fait le premier pas.**",
      "Une marche sans téléphone. Un matin sans fil d'actu. Le changement **commence ici**.",
    ],
    benefitsHeadline: "Voici comment **Screen0** peut vous aider cette semaine",
    benefits: [
      {
        title: "Concentrez-vous en quelques minutes",
        subtitle: "Configuration simple et personnalisable",
      },
      {
        title: "Récupérez plus de 2 heures par jour",
        subtitle: "Moins de scroll. Plus de temps pour l'essentiel.",
      },
      {
        title: "Accomplissez plus",
        subtitle: "Jusqu'à 50 % de productivité en plus au travail avec Screen0",
      },
      {
        title: "Dormez mieux",
        subtitle:
          "Arrêtez le scroll tard le soir avec un horaire de coucher qui fonctionne vraiment",
      },
    ],
    trialHeadline: "Essayez Premium **gratuitement.** Pas de surprise.",
    trialRows: [
      {
        dayLabel: "TODAY",
        title: "Aucun frais aujourd'hui",
        subtitle:
          "Accès aux fonctionnalités Premium comme Règles et Smart Blocks",
      },
      {
        dayLabel: "DAY 5",
        title: "Rappel avant la fin de l'essai",
        subtitle: "Nous vous rappellerons 2 jours avant la fin de votre essai gratuit",
      },
      {
        dayLabel: "DAY 7",
        title: "Annulez à tout moment",
        subtitle: "Les abonnements peuvent être annulés à tout moment",
      },
    ],
    primaryGoalQuestion: "Qu'est-ce qui compte le plus pour le temps que vous voulez ?",
    timeLostQuestion: "Où perdez-vous le plus de temps ?",
    timeLostSubtitle: "Vous avez choisi {goal} — où part le temps ?",
    difficultyQuestion: "À quel point est-il difficile de résister ?",
    goals: {
      work: "Travail",
      study: "Études",
      sleep: "Sommeil",
      family: "Famille",
      hobby: "Loisirs",
      exercise: "Exercice",
      balance: "Équilibre",
      wellness: "Bien-être",
      other: "Autre",
    },
    timeLostOptions: {
      social: "Réseaux sociaux",
      news: "Actualités",
      gaming: "Jeux",
      streaming: "Streaming",
      work: "Travail",
      shopping: "Achats",
      messages: "Messages",
      browsing: "Navigation",
      other: "Autre",
    },
    difficultyEmojis: ["😌", "🙂", "😐", "😣", "😫"],
    difficultyLevels: [
      "Très facile",
      "Facile",
      "Parfois difficile",
      "Difficile",
      "Très difficile",
    ],
    insight8ImageAlt: "Scène du soir avec téléphone rangé",
    insight8Headline: "**C'est important.**",
    insight8Body:
      "Protéger votre temps est l'une des limites qui fonctionnent vraiment. De petites limites mènent à un vrai changement.",
    insight8SleepHeadline: "**C'est important.**",
    insight8SleepBody:
      "Après 19 h le téléphone peut attendre. **Se déconnecter le soir** est l'une des limites qui fonctionnent.",
    insight9ImageAlt: "Illustration sur l'attention et les écrans",
    insight9SocialHeadline: "Vous êtes face à une **machine**.",
    insight9SocialBody: "Le fil n'a pas de fin — il est **conçu** ainsi.",
    insight9OtherHeadline: "Chaque notification **casse** votre concentration.",
    insight9OtherBody: "S'y remettre peut prendre **20 minutes**.",
    notificationsHeadline:
      "Nous vous enverrons un rappel **2 jours** avant la fin de votre essai",
    notificationsBody:
      "Autorisez les notifications pour recevoir un rappel avant le prélèvement",
    notificationsAllow: "AUTORISER LES NOTIFICATIONS",
    notificationsMaybeLater: "PLUS TARD",
    notificationsDeniedWarning:
      "Les notifications sont désactivées. Activez-les dans les Réglages pour que nous puissions vous rappeler avant la fin de votre essai.",
    setupImageAlt: "Illustration des permissions",
    setupTitle: "Une permission rapide",
    setupBody:
      "Screen0 a besoin de l'accès système pour afficher votre rapport personnel. Aucun compte requis.",
    setupNativeHint: "Vous pouvez changer cela à tout moment dans Réglages.",
    setupWebHint:
      "Sur le web, les rapports nécessitent l'app mobile. Vous pouvez continuer et configurer plus tard sur votre téléphone.",
    vpnImageAlt: "Illustration du filtre de sites sur l'appareil",
    vpnTitle: "Installez le filtre de sites",
    vpnBody:
      "Pour bloquer des sites dans Safari et les autres navigateurs mobiles, Screen0 doit ajouter un profil de filtre local.",
    vpnBodyAndroid:
      "Pour bloquer des sites dans Chrome et les autres navigateurs mobiles, Screen0 doit ajouter un profil de filtre local.",
    vpnPrivacyTitle: "Engagement pour la confidentialité",
    vpnPrivacyBody:
      "Cela ajoute un filtre sur l'appareil qui bloque uniquement les sites que vous choisissez. Tout le filtrage se fait sur votre téléphone — vos données ne quittent jamais l'appareil.",
    vpnWebHint:
      "Sur le web, le blocage de sites nécessite l'app mobile. Vous pouvez continuer et le configurer plus tard sur votre téléphone.",
    vpnInstall: "INSTALLER LE PROFIL",
    vpnNotNow: "PAS MAINTENANT",
    vpnErrorTitle: "Impossible d'installer le filtre",
    vpnErrorHint: "Le profil VPN n'a pas été ajouté. Vous pouvez passer pour l'instant et réessayer plus tard.",
    trackingImageAlt: "Illustration d'analyses anonymes",
    trackingTitle: "Soutenez un meilleur Screen0",
    trackingBody:
      "Autoriser le suivi anonyme nous aide à comprendre ce qui fonctionne et à améliorer l'app pour tous.",
    trackingPrivacyTitle: "Engagement pour la confidentialité",
    trackingPrivacyBody: "Pas de publicité, pas de données personnelles, aucune vente de vos données. Jamais.",
    trackingAllow: "CONTINUER",
    trackingNotNow: "PAS MAINTENANT",
    welcomeImageAlt: "Illustration de bienvenue",
    welcomeTitle: "Vous êtes prêt.",
    welcomeRecap:
      "Vous voulez plus de temps pour **{goal}**. Screen0 vous aidera à le protéger — dès aujourd'hui.",
    welcomeRecapFallback:
      "Screen0 vous aidera à protéger votre temps — dès aujourd'hui.",
    paywall: {
      headline: "Gagnez plus de 2 heures par jour avec Screen0 Premium",
      timeline: [
        {
          title: "Commencez votre parcours de concentration",
          description:
            "Vous êtes sur la bonne voie pour transformer l'intention en habitude quotidienne de focus.",
        },
        {
          title: "Aujourd'hui : reprenez le contrôle",
          description:
            "Débloquez des outils puissants comme les **Règles** et les **Smart Blocks**. Définissez votre première limite et protégez votre temps dès aujourd'hui.",
        },
        {
          title: "Jour 5 : sentez la différence",
          description:
            "À ce stade, vous remarquerez plus de calme, de clarté et de contrôle sur votre temps. Nous vous préviendrons avant la fin de l'essai — pas de surprise.",
        },
        {
          title: "Jour 7 : continuez",
          description:
            "Poursuivez votre parcours de focus avec Premium. Annulez à tout moment si ce n'est pas pour vous.",
        },
      ],
      timelineTrialDescriptionWithTrial:
        "Commencez votre essai gratuit de {trialDays} jours et débloquez des outils puissants comme **Règles** et **Smart Blocks**. Configurez votre première limite et protégez votre temps dès aujourd'hui.",
      timelineTrialDescriptionNoTrial:
        "Débloquez des outils puissants comme **Règles** et **Smart Blocks**. Configurez votre première limite et protégez votre temps dès aujourd'hui.",
      yearlyBadgeWithTrial: "{trialDays} jours d'essai gratuit, puis {price} /an",
      yearlyBadgeNoTrial: "{price} /an",
      yearlyTitle: "Annuel",
      yearlySubtext: "(Seulement {monthlyPrice} /mois — moins qu'un café)",
      lifetimeTitle: "À vie",
      lifetimeSubtext: "Achat unique. À vous pour toujours.",
      ctaYearly: "COMMENCER L'ESSAI GRATUIT",
      ctaLifetime: "OBTENIR L'ACCÈS À VIE",
      footerRenewal: "Renouvellement automatique jusqu'à annulation. Annulez à tout moment.",
      footerLifetime: "Achat unique. Pas d'abonnement.",
      termsLink: "Conditions",
      privacyLink: "Confidentialité",
      purchase: {
        processing: "Traitement…",
        genericError: "Une erreur s'est produite. Veuillez réessayer.",
        notEntitled: "Achat terminé, mais Premium n'est pas encore actif. Veuillez réessayer.",
        webUnavailable: "Les achats sont disponibles uniquement dans l'application Screen0.",
        configError: "Les achats ne sont pas disponibles pour le moment. Réessayez plus tard.",
        offeringsError: "Impossible de charger les prix. Vérifiez votre connexion et réessayez.",
        retry: "Réessayer",
        restorePurchases: "Restaurer les achats",
        restoreProcessing: "Restauration…",
        restoreSuccess: "Achats restaurés. Premium est actif.",
        restoreNothingFound: "Aucun achat à restaurer.",
        restoreNothingFoundApple: "Aucun achat trouvé pour cet identifiant Apple.",
        restoreNothingFoundGoogle: "Aucun achat trouvé pour ce compte Google Play.",
        restoreError: "Impossible de restaurer les achats. Veuillez réessayer.",
      },
    },
  },
  categories: {
    books: "Livres",
    business: "Business",
    catalogs: "Catalogues",
    developerTools: "Outils pour développeurs",
    education: "Éducation",
    entertainment: "Divertissement",
    finance: "Finance",
    foodAndDrink: "Alimentation et boissons",
    games: "Jeux",
    graphicsAndDesign: "Créativité",
    healthAndFitness: "Santé et forme",
    kids: "Enfants",
    lifestyle: "Style de vie",
    medical: "Médecine",
    miscellaneous: "Divers",
    music: "Musique",
    navigation: "Navigation",
    news: "Information et lecture",
    newsstand: "Kiosque",
    photoAndVideo: "Photo et vidéo",
    productivity: "Productivité et finances",
    reference: "Références",
    shopping: "Achats et alimentation",
    socialNetworking: "Social",
    sports: "Sport",
    stickers: "Autocollants",
    travel: "Voyages",
    system: "Système",
    utilities: "Utilitaires",
    weather: "Météo",
    uncategorized: "Autre",
    other: "Autre",
    website: "Site web",
  },
  websiteCategories: {
    modalTitle: "Catégories de sites",
    expandInfoAria: "Afficher les détails pour {name}",
    collapseInfoAria: "Masquer les détails pour {name}",
    toggleCategoryAria: "Activer ou désactiver {name}",
    domainsHeading: "Domaines inclus",
    removeCategoryAria: "Retirer {name}",
    browseCategoriesButton: "Catégories",
    browseCategoriesAria: "Ouvrir les catégories de sites",
    addWebsiteAria: "Ajouter un site web",
    social: {
      name: "Social",
      description: "Réseaux sociaux, forums et plateformes communautaires.",
    },
    meta: {
      name: "Meta",
      description: "Facebook, Instagram, WhatsApp et Messenger.",
    },
    messaging: {
      name: "Messagerie",
      description: "Applications de chat et services de messagerie directe.",
    },
    news: {
      name: "Actualités",
      description: "Sites d'actualités, éditeurs et médias d'information.",
    },
    dating: {
      name: "Rencontres",
      description: "Applications et sites de rencontres.",
    },
  },
});

export default FR_TRANSLATIONS;
